import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import {
    CartResult,
    UpdateCartApiParameter,
    updateCartWithResult,
} from "@insite/client-framework/Services/CartService";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/Cart/Handlers/SaveOrder";

export interface ShareOrderParam {
    canShareOrder?: string;
    emailList?: string | undefined;
    notes?: string | undefined;
}

export type SaveOrderParameter = HasOnError<string> & HasOnSuccess<string> & ShareOrderParam;

type HandlerType = ApiHandlerDiscreteParameter<SaveOrderParameter, UpdateCartApiParameter, CartResult>;

export const PopulateApiParameterExtended: HandlerType = props => {
    const cartState = getCurrentCartState(props.getState());

    if (!cartState.value) {
        throw new Error("There was no current cart and we are trying to save the current cart.");
    }

    props.apiParameter = {
        cart: {
            ...cartState.value,
            status: "Saved",
            properties: {
                ...cartState.value.properties,
                canShareOrder: props.parameter.canShareOrder ?? "",
                emailList: props.parameter.emailList || "",
                notes: props.parameter.notes || "",
            },
        },
    };
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterExtended);
